import React from "react";
import {
  Box,
  CssBaseline,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  AiFillHome,
  AiOutlineLogin,
  AiOutlineLogout,
  AiOutlineMenuFold,
} from "react-icons/ai";
import { GiWorld } from "react-icons/gi";
import { NavLink } from "react-router-dom";
import { IconStyle } from "./LeftMenu";
import Mic from "../assets/icons/mic.png";
import clapperboard from "../assets/icons/clapperboard.png";
import Sign from "../assets/images/sign.png";

const LeftMenuSmallScreen = ({
  loggedInUser,
  logout,
  closeLeftMenu,
  navigate,
  logo,
  isOpen,
}) => {
  return (
    <Box
      sx={{
        background: (theme) => theme.palette.primary.dark,
      }}
      className={`md-leftMenu md-leftMenuSmallScreen ${
        isOpen ? "open" : "close"
      }`}
    >
      <CssBaseline />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: (theme) => theme.palette.primary.light,
          paddingInline: 1,
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="prihaniway"
          className="md-logo-smallScreen"
          sx={{ mt: 0, width: "60px" }}
        />

        <IconButton
          onClick={closeLeftMenu}
          sx={{
            color: (theme) => theme.palette.primary.dark,
            fontSize: "30px",
          }}
        >
          <AiOutlineMenuFold />
        </IconButton>
      </Box>

      <Box
        sx={{
          flex: "1",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          mt: 1,
          pr: 1,
          pl: 1,
          overflow: "auto",
        }}
      >
        <Box
          className="md-leftMenu-mainButton mainButton"
          sx={{
            "&>a": {
              color: (theme) => theme.palette.secondary.main,
            },
          }}
        >
          <NavLink to="/" onClick={closeLeftMenu}>
            <AiFillHome />
            <Typography variant="body1" children="Home" />
          </NavLink>
          <a href="https://pirhaniway.com/">
            <GiWorld />
            <Typography variant="body1" children="Academy" />
          </a>
        </Box>

        <Box>
          <Typography
            variant="h6"
            children="Pirhani Way E-Book Website"
            color="white"
            sx={{ mb: 2 }}
            className="leftMenu-title"
          />
          <Typography
            variant="body1"
            children={MADE_WITH_LOVE_TEXT}
            color="white"
            className="leftMenu-text"
          />
          <Box
            sx={{ display: "flex", alignItems: "center", mt: 1 }}
            className={`${isOpen ? "signSection-smallScreen" : ""}`}
          >
            <Typography variant="body1" color="white" className="leftMenu-ceo">
              Ali Pirhani <br />
              CEO
            </Typography>
            <Box
              component="img"
              src={Sign}
              alt="prihaniway-sign"
              className="leftMenu-sign"
              sx={{ ml: 2, width: "60px" }}
            />
          </Box>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
          }}
          className="sm-audioSection"
        >
          <Box
            component="img"
            src={Mic}
            alt="microphone"
            className="md-mic-smallScreen"
            sx={{ mr: 2, width: "20px" }}
          />
          <Typography variant="body2" children="Dr Ali Pirhani" color="white" />
        </Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
          }}
          className="sm-developersSection"
        >
          <Box
            component="img"
            src={clapperboard}
            alt="microphone"
            className="md-mic-smallScreen"
            sx={{ mr: 2, width: "30px" }}
          />
          <Typography variant="body2" color="white">
            Alireza Haji Mohammad <br />
            Farshid Manoochehri <br />
            Mahdi Rasa <br />
            Amir Beigi <br />
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            pl: 1,
            mt: 1,
          }}
          className="smallLeftMenu-bottomBtn"
        >
          {loggedInUser?.username ? (
            <Tooltip title="logout">
              <IconButton
                sx={{ color: (theme) => theme.palette.primary.dark }}
                onClick={logout}
              >
                <AiOutlineLogout />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="login">
              <IconButton
                sx={{
                  ...IconStyle,
                  color: (theme) => theme.palette.primary.dark,
                }}
                onClick={() => {
                  navigate("/login");
                  closeLeftMenu();
                }}
              >
                <AiOutlineLogin />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default LeftMenuSmallScreen;

export const MADE_WITH_LOVE_TEXT =
  "The educational contents produced in Pirhani Way Academy is the result of many years of efforts and experiences of a professional team. It is hoped that the students will achieve good results by effective use of these materials";
